<template>
  <div class="cpd-activity-detail">
    <v-card flat>
      <v-card-text class="cpd-activity-detail__body">
        <div class="cpd-activity-detail__grid">
          <div class="cpd-activity-detail__item">
            <div class="cpd-activity-detail__label">CPD Activity Provider</div>
            <div class="cpd-activity-detail__value">
              {{ values.cpdProvider ? values.cpdProvider.trainingCenterName : "-" }}
            </div>
          </div>
          <div class="cpd-activity-detail__item">
            <div class="cpd-activity-detail__label">CPD Activity Type</div>
            <div class="cpd-activity-detail__value">
              {{ values.programType ? values.programType.name : "-" }}
            </div>
          </div>
          <div class="cpd-activity-detail__item">
            <div class="cpd-activity-detail__label">CPD Activity Category</div>
            <div class="cpd-activity-detail__value">
              {{ values.category ? values.category.name : "-" }}
              <span v-if="values.category" class="font-weight-medium">
                {{ values.category.categoryType === "CAT2" ? "(Category 2)" : "(Category 1)" }}
              </span>
            </div>
          </div>
          <div class="cpd-activity-detail__item">
            <div class="cpd-activity-detail__label">Activity Delivery</div>
            <div class="cpd-activity-detail__value">
              {{ values.activityDelivery ? values.activityDelivery.name : "-" }}
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-tabs v-model="tab" class="cpd-activity-detail__tabs">
      <v-tab>Course</v-tab>
      <v-tab>General Activity Information</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <v-card-text class="cpd-activity-detail__body">
            <div class="cpd-activity-detail__grid">
              <div class="cpd-activity-detail__item">
                <div class="cpd-activity-detail__label">Course Name</div>
                <div class="cpd-activity-detail__value">{{ courseName }}</div>
              </div>
              <div class="cpd-activity-detail__item">
                <div class="cpd-activity-detail__label">Continuing Education Unit</div>
                <div class="cpd-activity-detail__value">{{ courseCeu }}</div>
              </div>
              <div class="cpd-activity-detail__item">
                <div class="cpd-activity-detail__label">Course Level</div>
                <div class="cpd-activity-detail__value">{{ courseLevel }}</div>
              </div>
              <div class="cpd-activity-detail__item">
                <div class="cpd-activity-detail__label">Passing Score</div>
                <div class="cpd-activity-detail__value">{{ coursePassingScore }}</div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text class="cpd-activity-detail__body">
            <div class="cpd-activity-detail__grid">
              <div class="cpd-activity-detail__item">
                <div class="cpd-activity-detail__label">Facilitated By</div>
                <div class="cpd-activity-detail__value">
                  {{ values.facilitatedBy ? values.facilitatedBy : "-" }}
                </div>
              </div>
              <div class="cpd-activity-detail__item">
                <div class="cpd-activity-detail__label">Participants Number</div>
                <div class="cpd-activity-detail__value">
                  {{ values.participantsNumber ?? "-" }}
                </div>
              </div>
              <div class="cpd-activity-detail__item">
                <div class="cpd-activity-detail__label">Trainers Number</div>
                <div class="cpd-activity-detail__value">
                  {{ values.trainersNumber ?? "-" }}
                </div>
              </div>
              <div class="cpd-activity-detail__item">
                <div class="cpd-activity-detail__label">Start Date</div>
                <div class="cpd-activity-detail__value">
                  {{ values.startDate ?? "-" }}
                </div>
              </div>
              <div class="cpd-activity-detail__item">
                <div class="cpd-activity-detail__label">End Date</div>
                <div class="cpd-activity-detail__value">
                  {{ values.endDate ?? "-" }}
                </div>
              </div>
              <div class="cpd-activity-detail__item">
                <div class="cpd-activity-detail__label">Collaborator</div>
                <div class="cpd-activity-detail__value">
                  {{ values.collaborator ?? "-" }}
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>


<script>
export default {
  props: {
    program: Object,
  },
  data() {
    return {
      values: {},
      tab: 0,
    };
  },
  computed: {
    programCourse() {
      return this.values?.program_courses?.length ? this.values.program_courses[0].course : null;
    },
    courseName() {
      return this.values?.courseTitleCat2 || this.programCourse?.courseName || "-";
    },
    courseCeu() {
      return this.values?.ceu ?? this.programCourse?.continualEducationUnit ?? "-";
    },
    courseLevel() {
      return this.values?.courseLevel?.name || this.programCourse?.courseLevel?.name || "-";
    },
    coursePassingScore() {
      return this.values?.cat2PassingScore ?? this.programCourse?.passingScore ?? "-";
    },
  },
  watch: {
    program: {
      immediate: true,
      handler(value) {
        this.values = value || {};
      },
    },
  },
};
</script>

<style scoped>
.cpd-activity-detail__body {
  padding: 16px 20px 24px;
}

.cpd-activity-detail__grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 12px;
}

@media (min-width: 768px) {
  .cpd-activity-detail__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.cpd-activity-detail__item {
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  min-height: 64px;
}

.cpd-activity-detail__label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 6px;
  display: block;
}

.cpd-activity-detail__value {
  font-size: 13px;
  color: #0f172a;
}

.cpd-activity-detail__tabs {
  margin-top: 8px;
}
</style>
<style>
.v-dialog > .v-card > .v-toolbar {
  position: sticky;
  top: 0;
  z-index: 999;
}
</style>
